import {
  Item,
  ItemTypes,
  ItemWithMetaData,
  ProfileAddedBy,
  Type,
} from "../api/Items";
import ErrorMessageContainer from "../shared-components/ErrorMessageContainer";
import ProfileAdd from "./ProfileAdd";
import ProfileDisplay from "./ProfileDisplay";

type ConfirmedProfilesProps = {
  profileList: ItemWithMetaData[];
  isReadOnly: boolean;
  handleAddProfile?: (inputUrl: string) => void;
  handleDeleteProfile?: (itemUUID: string) => void;
  errorMessage?: string;
};

export const ManualConfirmedProfiles = ({
  profileList,
  isReadOnly,
  handleAddProfile,
  handleDeleteProfile,
  errorMessage,
}: ConfirmedProfilesProps) => {
  const manuallyAddedProfiles = filterProfiles(profileList, true);
  return (
    <div className="mt-4">
      <div className="text-2xl font-semibold mb-6">Manually Added Profiles</div>
      <div className="container mx-auto bg-gray-50 rounded-lg p-4">
        <div className="font-semibold pb-4">Add Profiles</div>
        {!isReadOnly && (
          <div>
            <ProfileAdd
              handleAddProfile={(inputUrl) => handleAddProfile?.(inputUrl)}
            />
            {errorMessage && <ErrorMessageContainer message={errorMessage} />}
          </div>
        )}
        <div className="block h-1 border-solid border-t-2 mt-5"></div>
        <ProfileDisplay
          isManualAdd={true}
          profileList={manuallyAddedProfiles}
          tabColor="green"
          isReadOnly={isReadOnly}
          onDelete={handleDeleteProfile}
          isSidebar={false}
          showAddedBy={false}
        />
      </div>
    </div>
  );
};

const filterProfiles = (
  profilesList: ItemWithMetaData[],
  manuallyAdded: boolean
) => {
  if (!profilesList) {
    return [];
  }
  const filtered: ItemWithMetaData[] = [];
  profilesList.forEach((itemWithMetaData: ItemWithMetaData) => {
    let type: Type = itemWithMetaData.type;
    let item: Item = itemWithMetaData.item;
    const itemIsProfile: boolean = type.name === ItemTypes.SOCIAL_MEDIA_PROFILE;
    if (
      itemIsProfile &&
      (item.manually_added === manuallyAdded || item.is_reviewed) &&
      item.in_report &&
      item.content?.added_by !== ProfileAddedBy.CLIENT
    ) {
      filtered.push(itemWithMetaData);
    }
  });
  return filtered;
};
